import { render, staticRenderFns } from "./HisItemComponent.vue?vue&type=template&id=b0ba00b0&scoped=true&"
import script from "./HisItemComponent.vue?vue&type=script&lang=ts&"
export * from "./HisItemComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ba00b0",
  null
  
)

export default component.exports